import {
  getDeleteApiV1ThreeLetterCodePartnerAdminsGroupsIdMutationFetcher,
  getPostApiV1ThreeLetterCodePartnerAdminsGroupsMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';
import type { Key } from 'swr';

/**
 * グループ削除APIを実行するカスタムフック
 *
 * @param threeLetterCode - パートナーコード
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const useDeletePartnerAdminsGroup = (
  threeLetterCode: string,
  options?: {
    onSuccess?: () => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPostApiV1ThreeLetterCodePartnerAdminsGroupsMutationKey(threeLetterCode),
    (_: Key, { arg }: { arg: number }) =>
      getDeleteApiV1ThreeLetterCodePartnerAdminsGroupsIdMutationFetcher(threeLetterCode, arg),
    options
  );
};
